import { useCallback, useState } from 'react'

interface UseSetProps<T> {
  set: Set<T>
  add: (subset: readonly T[]) => void
  remove: (subset: readonly T[]) => void
}

export function useSet<T>(): UseSetProps<T> {
  const [set, setSet] = useState(() => new Set<T>())

  const add = useCallback(
    (subset: readonly T[]) =>
      setSet(s => {
        const n = new Set(s)
        subset.forEach(v => n.add(v))
        return n
      }),
    []
  )

  const remove = useCallback(
    (subset: readonly T[]) =>
      setSet(s => {
        const n = new Set(s)
        subset.forEach(v => n.delete(v))
        return n
      }),
    []
  )

  return { set, add, remove }
}
